export const UI_SELECT_TAG = 'ui/SELECT_TAG'
export const UI_TOGGLE = 'ui/TOGGLE'
